import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import Collapse from '@material-ui/core/Collapse';

import SimpleAlert from './SimpleAlert';
import SnackbarAlert from './SnackbarAlert';

const CompositeAlert = ({ message, variant, width, transitionDuration, subText }) => {
  const isMobile = isWidthDown('xs', width);
  const [stateSimpleAlertVisible, setStickyAlertVisible] = React.useState(false);

  React.useEffect(() => {
    const timerId = setTimeout(() => {
      setStickyAlertVisible(isMobile);
    }, transitionDuration);

    return () => {
      clearTimeout(timerId);
    };
  }, [isMobile]);

  if (isMobile) {
    return (
      <Fragment>
        {isMobile && !stateSimpleAlertVisible && (
          <SnackbarAlert
            variant={variant}
            message={message}
            autoHideDuration={transitionDuration}
            allowClose={false}
          />
        )}
        <Collapse in={stateSimpleAlertVisible}>
          <SimpleAlert variant={variant} message={message} />
        </Collapse>
      </Fragment>
    );
  }

  return <SimpleAlert variant={variant} message={message} subText={subText} />;
};

CompositeAlert.propTypes = {
  message: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  width: PropTypes.string,
  transitionDuration: PropTypes.number,
};

CompositeAlert.defaultProps = {
  variant: 'success',
  width: 'sm',
  transitionDuration: 2000,
};

export default withWidth()(CompositeAlert);
